module.exports = __webpack_public_path__ + "media/icons/naped-tyl-grey@3x-9b834c8d.svg";